export function isValueChanged(value1: unknown, value2: unknown): boolean {
  return !!(value1 != value2 && (value1 || value2))
}
